import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const NoBookmark = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 121 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Frame">
        <g id="Group">
          <g id="Clip path group">
            <mask
              id="mask0_2982_23995"
              style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="121"
              height="120"
            >
              <g id="a">
                <path id="Vector" d="M0.5 0.000358582H120.5V120H0.5V0.000358582Z" fill="white" />
              </g>
            </mask>
            <g mask="url(#mask0_2982_23995)">
              <g id="Group_2">
                <path
                  id="Vector_2"
                  d="M118.156 93.705V13.1248H104.094V93.705L111.125 106.875L118.156 93.705Z"
                  fill="white"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="22.926"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_3"
                  d="M87.2185 108.281C87.2185 113.437 82.9998 117.656 77.8435 117.656H2.84375V2.34361H77.8435C82.9998 2.34361 87.2185 6.56235 87.2185 11.7186V108.281Z"
                  fill="white"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="22.926"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_4"
                  d="M40.2617 73.7221L50.4369 70.4938L50.8906 70.3498L51.3442 70.4938L61.5194 73.7221V68.0688L55.0081 64.2957L54.2323 63.8462L54.2609 62.95L54.7215 48.5201L54.7805 46.6696L56.5785 47.1112L70.4842 50.5265V44.9686L55.8961 37.3332L55.0647 36.8981L55.0924 35.96L55.364 26.7561C55.4042 25.3917 55.018 23.8998 54.2414 22.7901C53.4966 21.7259 52.4125 21.0219 50.8906 21.0219C49.3649 21.0219 48.2814 21.7231 47.5385 22.782C46.7636 23.8867 46.3765 25.3774 46.4171 26.7561C46.4171 26.7562 46.4171 26.7562 46.4171 26.7562L46.6888 35.96L46.7164 36.8981L45.885 37.3332L31.2969 44.9686V50.5265L45.2026 47.1112L47.0006 46.6696L47.0597 48.5201L47.5202 62.95L47.5488 63.8462L46.773 64.2957L40.2617 68.0688V73.7221Z"
                  fill="#CCE7FE"
                  stroke="#686869"
                  strokeWidth="3"
                />
                <path
                  id="Vector_5"
                  d="M106 89H116V25H106V89Z"
                  fill="#CCE7FE"
                  fillRule="evenodd"
                  clipRule="evenodd"
                />
                <path
                  id="Vector_6"
                  d="M14.5625 3.51548V116.484"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="22.926"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_7"
                  d="M29.7969 91.1023H71.9845"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="22.926"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  id="Vector_8"
                  d="M38.7617 100.477H63.0197"
                  stroke="#686869"
                  strokeWidth="3"
                  strokeMiterlimit="22.926"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

NoBookmark.displayName = 'NoBookmark';
